import React, {useState} from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import {ReactComponent as Textph} from "../../assets/svg/illustration-woman-online-mobile.svg"

const VideoEn = ()=>{
    return(
        <div className='text-wrap'>
            <div className='text-dec'>
                <Nav/>
                <main className="card">
                    <div className="hero">
                        <Textph/>
                    </div>
                    <h2 className="title">Video guide</h2>
                    <div className="acc-container">
                        <h3>BellMeet Site guide</h3>
                        <TextItem
                            title={'How to work with the panel'}
                        >
                           {/* <div className="video-guide">
                                <p>Comming soon</p>
                            </div>*/}
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/panel-Final.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                        <h3>BellMeet Room</h3>
                        <TextItem
                            title={'How to work with the room'}
                        >
                            <video controls>
                                <source src="https://bellmeet.com/helpvideo/Room-Final.mp4" type="video/mp4" />
                                Your browser does not support HTML video.
                            </video>
                        </TextItem>
                    </div>
                </main>
                <Footer/>
            </div>
        </div>
    )
}

const TextItem = ({title,children,defOpen = false}) =>{
    const [isOpen,setIsOpen] = useState(defOpen)
    return(
        <>
            <button onClick={()=>setIsOpen(p=>!p)} className={`acc-btn ${isOpen ? 'active' : ''}`}>{title}</button>
            <div className={`acc-content ${isOpen ? 'active' : ''}`}>
                {children}
            </div>
        </>
    )
}

export default VideoEn